import React, { Component } from 'react'
import axios from 'axios'
import Auth from '../../Modules/Auth'
import { withCookies, Cookies } from 'react-cookie'
import { Link } from 'react-router-dom'
import './TodoDetailPage.scss'
import CommentList from '../../Components/Commons/CommentList'
import ResultForm from '../../Components/Todo/ResultForm'
// import $ from 'jquery'
// import jQuery from 'jquery'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
// import PDFReader from '../../Components/Commons/PDFReader'
// import ImageZoom from 'react-medium-image-zoom'
import {
    RoleStr,
    renderFiles,
    renderPDFFiles,
    renderImageFiles,
    renderOfficeFiles,
    renderVideoFiles,
} from '../../Components/Commons/Utils'

class TodoDetailPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            todo: null,
            resultForm: false,
            user: null,
            deletePop: false,
        }
    }

    UNSAFE_componentWillMount() {
        this.loadUser()
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    loadUser = () => {
        axios
            .get(`${BACKEND_HOST}/auth/me`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res.data)
                this.setState({ user: res.data })
                this.loadTodo()
            })
            .catch((err) => {
                console.log(err)
            })
    }

    loadTodo = () => {
        axios
            .get(`${BACKEND_HOST}/rfis/${this.props.match.params.id}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res.data)
                this.setState({ todo: res.data })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    deleteTodo = () => {
        axios
            .delete(`${BACKEND_HOST}/rfis/${this.props.match.params.id}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.setState({
                    deletePop: false,
                })
                window.location.href = '/todo'
            })
            .catch((err) => {
                console.log(err)
            })
    }

    openResult = () => {
        this.setState({
            resultForm: true,
        })
    }

    closeResult = () => {
        this.setState({
            resultForm: false,
        })
    }

    render() {
        if (this.state.todo) {
            //날짜 변환
            let dueDate = ''
            if (this.state.todo.dueDate) {
                const newDate = new Date(this.state.todo.dueDate)
                const newYear = newDate.getFullYear()
                const week = new Array('일', '월', '화', '수', '목', '금', '토')
                const newDayName = week[newDate.getDay()]

                let newMonth = newDate.getMonth() + 1
                if (newMonth < 10) {
                    newMonth = '0' + newMonth
                }
                let newDay = newDate.getDate()
                if (newDay < 10) {
                    newDay = '0' + newDay
                }

                dueDate = `${newYear}.${newMonth}.${newDay} (${newDayName})`
            } else {
                dueDate = '지정안됨'
            }

            let assignee = ''
            if (this.state.todo.assignee && this.state.todo.assignee_id) {
                assignee = this.state.todo.assignee.name
            } else {
                assignee = '지정안됨'
            }

            return (
                <div>
                    <HeaderMenu />
                    <div className="section_wrap section_wrap_menu">
                        <div className="todo_detail_wrap common_detail">
                            <div className="section">
                                <div className="top_wrap">
                                    <div className="page_name">건축주 할 일</div>
                                    <h1>{this.state.todo.title}</h1>
                                    <ul className={this.state.user._id === this.state.todo.writer_id && 'writer'}>
                                        <li>
                                            <p className="title">요청자</p>
                                            <p className="content">{this.state.todo.writer.name}</p>
                                        </li>
                                        <li>
                                            <p className="title">담당자</p>
                                            <p className="content">{assignee}</p>
                                        </li>
                                        <li>
                                            <p className="title">마감일</p>
                                            <p className="content">{dueDate}</p>
                                        </li>
                                    </ul>
                                </div>
                                {this.state.todo.files.length !== 0 && (
                                    <div className="text_wrap">
                                        <div className="content">{renderFiles(this.state.todo.files)}</div>
                                    </div>
                                )}
                                {this.state.todo.files.length !== 0 && renderPDFFiles(this.state.todo.files)}
                                {this.state.todo.files.length !== 0 && renderOfficeFiles(this.state.todo.files)}
                                {this.state.todo.files.length !== 0 && renderImageFiles(this.state.todo.files)}
                                <div className="todo_content">
                                    <div
                                        className="inner_html"
                                        dangerouslySetInnerHTML={{ __html: this.state.todo.content }}></div>
                                </div>
                                {/* {this.state.user._id === this.state.todo.writer_id &&
                                    this.state.todo.status !== 'CLOSE' && (
                                        <ul className="btn_wrap">
                                            <li
                                                className="gray_btn_s"
                                                onClick={() => this.setState({ deletePop: true })}>
                                                삭제
                                            </li>
                                            <Link to={`/todo/write/${this.state.todo._id}`}>
                                                <li className="green_btn_s">수정</li>
                                            </Link>
                                        </ul>
                                    )} */}

                                {this.state.deletePop && (
                                    <div className="alret_pop2_bg">
                                        <div className="alret_pop2_wrap">
                                            <p className="h1_text">삭제하시겠습니까?</p>
                                            <p>삭제하면 복원할 수 없습니다.</p>
                                            <div
                                                className="btn btn1"
                                                onClick={() => this.setState({ deletePop: false })}>
                                                아니오
                                            </div>
                                            <div className="btn btn2" onClick={() => this.deleteTodo()}>
                                                네
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="comment_show">
                                    <CommentList
                                        project_id={this.state.todo._project}
                                        id={this.props.match.params.id}
                                        page={'client_todo'}
                                        url={'RFI'}
                                    />
                                </div>

                                {this.state.resultForm === false &&
                                    !this.state.todo.response.createdAt &&
                                    this.state.user._id === this.state.todo.assignee_id && (
                                        <div onClick={this.openResult}>
                                            <div className="full_btn_pc pc_v">처리결과 등록</div>
                                            <div className="full_btn_m mobile_v">처리결과 등록</div>
                                        </div>
                                    )}
                            </div>

                            {this.state.resultForm === true && (
                                <ResultForm
                                    todo={this.state.todo}
                                    closeResult={this.closeResult}
                                    id={this.props.match.params.id}
                                    user={this.state.user}
                                    disabled={false}
                                    history={this.props.history}
                                />
                            )}

                            {this.state.todo.response.createdAt && (
                                <ResultForm
                                    todo={this.state.todo}
                                    closeResult={this.closeResult}
                                    id={this.props.match.params.id}
                                    user={this.state.user}
                                    disabled={true}
                                    history={this.props.history}
                                />
                            )}

                            <Link to={`/todo/`}>
                                <div className="list_btn common_wrap">
                                    목록
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8">
                                        <g
                                            fill="none"
                                            fillRule="evenodd"
                                            stroke="#6D7075"
                                            strokeLinecap="round"
                                            strokeWidth="1.2">
                                            <path d="M.674 1H9.32M.674 4.06h6.277M.674 7.06h8.65" />
                                        </g>
                                    </svg>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div>
                <HeaderMenu />
                <div className="section_wrap"></div>
            </div>
        )
    }
}

export default withCookies(TodoDetailPage)



// WEBPACK FOOTER //
// ./Src/Containers/Todo/TodoDetailPage.js